import { render, staticRenderFns } from "./NotificationsPopover.vue?vue&type=template&id=4b765a94&scoped=true&"
import script from "./NotificationsPopover.vue?vue&type=script&lang=js&"
export * from "./NotificationsPopover.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsPopover.vue?vue&type=style&index=0&id=4b765a94&prod&scoped=true&lang=scss&"
import style1 from "./NotificationsPopover.vue?vue&type=style&index=1&id=4b765a94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b765a94",
  null
  
)

export default component.exports